module.exports = __webpack_public_path__ + "img/house-5.721effb4.jpeg";